<template>
  <div class="w-full flex flex-row justify-between rounded bg-danger-gradient px-2 my-2 space-x-2" v-if="this.$store.state.Shop.upgradeCase > 0">
    <div class="flex flex-row justify-start space-x-2">
      <div class="flex px-2">
        #{{ this.$store.state.Shop.upgradeCase }}
      </div>

      <div v-if="currentCase.patient">
        <span>{{ $t('pages.cases.casePreview.patient') }}:</span>
        {{ currentCase.patient.getDisplayName() }}
      </div>

      <div v-if="requesterName">
        <span>{{ $t('pages.cases.caseView.requester') }}:</span>
        {{ requesterName }}
      </div>
    </div>


    <feather-icon icon="XIcon" @click="removeCaseUpgrade" class="cursor-pointer"></feather-icon>
  </div>
</template>

<script>
import CaseService from "@/services/Case.service";
import {showErrorNotify} from "@/helpers/functionsHelpers";

export default {
  name: "CaseUpgrade",
  data() {
    return {
      requesterName: ''
    }
  },
  computed: {
    currentCase() {
      return this.$store.getters['Case/getCase'](this.$store.state.Shop.upgradeCase);
    },
  },
  methods: {
    populateData() {
      this.$store.dispatch('Users/lookupUser', this.currentCase.owner_id).then((response) => {
        this.requesterName = response.dataGeneral.displayName;
      }, error => {
        showErrorNotify(this, error);
      });
    },
    getCase() {
      const case_id = this.$store.state.Shop.upgradeCase;
      if (case_id > 0) {
        CaseService.getCase(case_id).then((response) => {
          this.$store.dispatch('Case/setCase', response).then(() => {
            this.populateData();
            this.loaded = true;
          }, error => {
            this.loadingMessage = error.message;
            this.loaded = false;
          });
        }, error => {
          showErrorNotify(this, error);
        });
      }
    },
    removeCaseUpgrade() {
      this.$alma.dialogConfirm({
        title: this.$t('pages.shop.checkout.upgrade.cancelUpgradeTitle'),
        textBody: this.$t('pages.shop.checkout.upgrade.cancelUpgradeBody'),
      }).then((confirm) => {
        if (confirm) {
          this.$store.dispatch('Shop/resetCaseUpgrade');
        }
      });
    }
  },
  mounted() {
    this.getCase();
  }
}
</script>

<style scoped>

</style>
